/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Company_Taxpayer_Id_DescriptionInputs */

const es_co2_signup_company_taxpayer_id_description = /** @type {(inputs: Signup_Company_Taxpayer_Id_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de identificación tributaria, sin el dígito de verificación (DV). Entre 5 y 10 dígitos.`)
};

/**

* @param {Signup_Company_Taxpayer_Id_DescriptionInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_company_taxpayer_id_description = /** @type {((inputs?: Signup_Company_Taxpayer_Id_DescriptionInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Company_Taxpayer_Id_DescriptionInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_company_taxpayer_id_description(inputs)
});